import {Button} from "../../../index";
import React, {useEffect, useState} from "react";
import {useViewerStore} from "../../../../store/store";
import {Alert, Table} from "antd";
import {RefreshShade} from "../Three-JS-Viewer/Controllers/RefreshShade";
import {ACCESS_MULTIPLIERS, siteCalculationState} from "../../../../services/siteCalculationState";
import {lossesColumns, VendorKey, vendorLossesValues} from "../../../../Constants";
import SiteReportPopup from "../Modal/Modal-Content/SiteReportPopup";
import { useCurrentUser } from "../../../../contexts/UserContext";

interface ToggleLossesConfirmProps {
    vendor: VendorKey,
    closeConfirm: () => void,
    callBackOnCancel: () => void,
}

function isVendorPendingChange(storeVendor: string | null, previewVendor: VendorKey): boolean {
    const committed = storeVendor ?? 'oneDRAW';
    const normalized = committed === 'OneDraw' ? 'oneDRAW' : committed;
    return normalized !== previewVendor;
}

const ToggleLossesConfirm: React.FC<ToggleLossesConfirmProps> = ({vendor, closeConfirm, callBackOnCancel}) => {
    const sceneViewer = useViewerStore(state => state.sceneViewer);
    const [lossData, setLossData] = useState<typeof vendorLossesValues[VendorKey]>([]);
    const selectedLossesVendor = useViewerStore(state => state.selectedLossesVendor);
    const isPendingChange = isVendorPendingChange(selectedLossesVendor, vendor);
    const {hasCapability} = useCurrentUser();

    useEffect(() => {
        setLossData(vendorLossesValues[vendor] ?? []);
    }, [vendor]);

    const confirm = (isGenerate: boolean) => {
        sceneViewer.viewerAlert({show: false})

        sceneViewer?.viewerAlert({
            show: true,
            title: "Refreshing shade with new losses...",
            message: `Vendor Losses have been updated to ${vendor}`,
            messageType: "info",
            isModal: false,
            isCloseAfterDisplay: true,
            autoCloseSeconds: 4000
        });

        useViewerStore.setState({
            selectedLossesVendor: vendor
        })
        siteCalculationState.needsUpdate(ACCESS_MULTIPLIERS, sceneViewer.roofs[0].faces.length - 1);
        siteCalculationState.useCalculations(ACCESS_MULTIPLIERS);
        RefreshShade();
        if (isGenerate) {
            sceneViewer.viewerAlert({
                show: true,
                title: "Download Site Report",
                message: <SiteReportPopup/>,
                messageType: "info",
                isModal: true
            })
        }
        closeConfirm();
    }

    const cancel = () => {
        callBackOnCancel()
        closeConfirm()
    }

    return (
        <>
            

            {
                hasCapability('Losses_Breakdown') &&
                <>
                {
                isPendingChange &&
                <>
                    <Alert
                        className="losses-vendor-alert"
                        message={`You are viewing losses for ${vendor}.`}
                        type='info'
                        showIcon/>
                    <br/>
                </>
                }
                <Table
                dataSource={lossData}
                columns={lossesColumns}
                pagination={false}
                style={{width: '100%'}}
                bordered={true}
                rowKey="lossName"
                rowClassName={() => "compact-row"}
                className="losses-table"
            />
             <br/>
                </>
            }

            {isPendingChange &&
                <>
                   
                    <Alert
                        className="losses-vendor-alert"
                        message="Note that confirming will result in a refresh of the site. All changes will be lost."
                        type="error" showIcon/>
                    <br/>

                    <div className={"modal-bottom-action-button-container"} style={{gap: '10px', justifyContent: 'center'}}>
                        <Button
                            variant="btn-primary"
                            size="btn-sm"
                            className="editor__control--finalize modal-cancel-button"
                            onClick={cancel}
                        >
                            Cancel
                        </Button>

                        <Button
                            variant="btn-primary"
                            size="btn-sm"
                            className="editor__control--finalize modal-confirm-button"
                            onClick={() => confirm(false)}
                        >
                            Confirm
                        </Button>

                        <Button
                            variant="btn-primary"
                            size="btn-sm"
                            className="editor__control--finalize"
                            disabled={!isPendingChange}
                            onClick={() => confirm(true)}
                        >
                            Generate
                        </Button>
                    </div>
                </>
            }
        </>
    )
}

export default ToggleLossesConfirm;
